import styled from "styled-components";
import { adminShellMetrics } from "../../theme";

// gos-admin's shell: the topbar spans the full width and the sider hangs
// below it, so the brand stays put while the content column scrolls.
const Wrapper = styled.div`
  .admin-loading {
    display: flex;
    justify-content: center;
    padding: 120px;
  }

  .admin-layout {
    min-height: 100vh;
    background: var(--atlas-background);
  }

  .admin-body-layout {
    min-height: 0;
  }

  .admin-sider {
    border-right: 1px solid var(--atlas-border);
  }

  .admin-content {
    margin: ${adminShellMetrics.contentInset}px;
  }

  .admin-footer {
    padding: 12px;
    border-top: 1px solid var(--atlas-border);
    background: var(--atlas-background-accent);
    color: var(--atlas-muted-foreground);
    text-align: center;
    font-size: 12px;
  }
`;

export default Wrapper;
